export enum TagEnum {
  NOVO = 1,
  'PEDIDO AGUARDANDO MATCH',
  AGENDADO,
  REAGENDADO,
  'CANCELADO PELO CLIENTE',
  'CANCELADO PELA AGYX',
  REALIZADO,
  CONCLUIDO,
  PAGO,
  AVALIADO,
  'NÃO AVALIADO',
  SEGUNDO_MATCH,
  EXPIRADO,
  'EM ESPERA',
}

export enum ActivityTagEnum {
  NOVO = 1,
  'PEDIDO AGUARDANDO MATCH',
  AGENDADO,
  REAGENDADO,
  'CANCELADO PELO CLIENTE',
  'CANCELADO PELA AGYX',
  REALIZADO,
  CONCLUIDO,
  PAGO,
  AVALIADO,
  'NÃO AVALIADO',
  SEGUNDO_MATCH,
  EXPIRADO,
  'EM ESPERA',
  'ATENDIMENTO RECEBIDO PELO CLIENTE',
  'ATENDIMENTO RECEBIDO POR TERCEIRO',
  'SERVIÇO INICIADO',
  'FOTOS ENVIADAS',
}

export const TagID: { [key: string]: number } = {
  NOVO: 1,
  'AGUARDANDO MATCH': 2,
  AGENDADO: 3,
  REAGENDADO: 4,
  'CANCELADO PELO CLIENTE': 5,
  'CANCELADO PELA AGYX': 6,
  REALIZADO: 7,
  CONCLUIDO: 8,
  PAGO: 9,
  AVALIADO: 10,
  NAO_AVALIADO: 11,
  'SEGUNDO MATCH': 12,
  '2° MATCH': 12,
  EXPIRADO: 13,
};
